// extracted by mini-css-extract-plugin
export var container = "_59-0";
export var icon = "_59-1";
export var text = "_59-2";